import { ICustomerConfig } from "@shared/modules/customer";
import { environment } from "../../environments/environment";

export const CompanyCustomerConfig: ICustomerConfig = {
    trackingParam: 't',
    useTokenInterceptor: true,
    useTrackingInterceptor: true,
    customerSpaceUrl: environment.customerSpaceUrl,
}